import Step1 from "./Step1";
import Step2 from "./Step2";
import Step3 from "./Step3";
import Step8 from "./Step8";

const GroupedStep1 = ({
  setText,
  text,
  ddKommun,
  ddProdukt,
  remValKommun,
  setRemValKommun,
  remValLine,
  setRemValLine,
  sla,
  setSla,
  account,
  validateIsErr,
  isBack = false,
  setIsBack,
  files,
  setFiles,
  formToShow,
  agreementInfoText,
  agreementInfoSeverity,
  extraProducts,
  hasExtraProducts,
}) => {
  const shouldShowStep = (stepIndex) => {
    return formToShow?.some(
      (step) => step.Index === stepIndex && step.IsActivated,
    );
  };

  return (
    <>
      {shouldShowStep(1) && (
        <Step1
          setText={setText}
          text={text}
          ddKommun={ddKommun}
          ddProdukt={ddProdukt}
          remValKommun={remValKommun}
          setRemValKommun={setRemValKommun}
          remValLine={remValLine}
          setRemValLine={setRemValLine}
          sla={sla}
          setSla={setSla}
          account={account}
          validateIsErr={validateIsErr}
          isBack={isBack}
          setIsBack={setIsBack}
          agreementInfoText={agreementInfoText}
          agreementInfoSeverity={agreementInfoSeverity}
          productCatalogueItems ={extraProducts}
          hasExtraProducts={hasExtraProducts}
        />
      )}

      {shouldShowStep(2) && (
        <Step2 setText={setText} text={text} validateIsErr={validateIsErr} />
      )}

      {shouldShowStep(3) && (
        <Step3 setText={setText} text={text} validateIsErr={validateIsErr} />
      )}

      {shouldShowStep(8) && (
        <Step8
          setText={setText}
          text={text}
          files={files}
          setFiles={setFiles}
        />
      )}
    </>
  );
};

export default GroupedStep1;
